import { ref } from 'vue'

export const SIDEBAR_STORAGE_KEY = 'ggi.layout.sidebarCollapsed'

function read(): boolean {
  try {
    return localStorage.getItem(SIDEBAR_STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

function write(value: boolean): void {
  try {
    localStorage.setItem(SIDEBAR_STORAGE_KEY, value ? '1' : '0')
  } catch {
    // Storage unavailable (private mode, quota): the preference just won't persist.
  }
}

/** Desktop sidebar collapsed state, persisted in localStorage. */
export function useSidebarCollapsed() {
  const collapsed = ref(read())

  function setCollapsed(value: boolean): void {
    collapsed.value = value
    write(value)
  }

  return { collapsed, setCollapsed, toggle: () => setCollapsed(!collapsed.value) }
}
